import type { Optional } from '@festina-life/core'

import {
  isParameterDefinitionInOutFromParameterDetailsField,
  type ParameterDetailsField,
} from '../../../types/parameterModel'
import { ParameterDefinitionDetails } from './ParameterDefinitionDetails'
import { ParameterDimensionDefinitionDetails } from './ParameterDimensionDefinitionDetails'

type Props = {
  data: Optional<ParameterDetailsField>
}

export const ParameterDetailsContentSelector = ({ data }: Props) => {
  if (!data) {
    return null
  }

  return isParameterDefinitionInOutFromParameterDetailsField(data) ? (
    <ParameterDefinitionDetails />
  ) : (
    <ParameterDimensionDefinitionDetails data={data} />
  )
}
